import { Model } from "@vuex-orm/core";

export default class ProjectTag extends Model {
  static entity = 'projectags';

  static $fetch() {
    return this.api().get('ProjectTags/')
  }
  static $get (id) {
    return this.api().get(`ProjectTags/${id}/`)
  }
  static $post (data) {
    return this.api().post(`ProjectTags/`, data)
  }
  static $put (id, data) {
    return this.api().put(`ProjectTags/${id}/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(""),
      icon: this.string(""),
      color: this.string("")
    };
  }
}
